import { contentTemplates } from './index';

/**
 * This file defines all possible template types used in the app. The ony place it used is layout.utils inside the "logic" module.
 * TODO: remove the coupling between view and logic layers by moving a list of all possible templates into app config.
 */

export const templateTypes = {
  ...Object.keys(contentTemplates).reduce((result, key) => ({ ...result, [key]: key }), {}),
  // The Player template is not a part of catalog layout, however it shouldn't be filtered out upon layout parsing
  Player: 'Player',
  HorizontalEpg: 'HorizontalEpg',
};

export const selectorTemplateTypes = {
  Selector: 'Selector',
  Tab: 'Selector',
};

export const blockTemplateTypes = {
  List: 'List',
  SlideShow: 'SlideShow',
  Solo: 'Solo',
  Grid: 'Grid',
  Belly: 'Belly',
  // The SideGlass template is not a part of catalog layout, however it shouldn't be filtered out upon layout parsing
  SideGlass: 'SideGlass',
  HorizontalEpg: 'HorizontalEpg',
};
